<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M29.4648 8C29.7992 8 30.1114 8.1671 30.2969 8.4453L34 14H42C43.1046 14 44 14.8954 44 16V38C44 39.1046 43.1046 40 42 40H6C4.89543 40 4 39.1046 4 38V16C4 14.8954 4.89543 14 6 14H14L17.7031 8.4453C17.8886 8.1671 18.2008 8 18.5352 8H29.4648ZM31 26C31 29.866 27.866 33 24 33C20.134 33 17 29.866 17 26C17 22.134 20.134 19 24 19C27.866 19 31 22.134 31 26Z"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
